import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "code-editor-window" }
const _hoisted_2 = { class: "window-header" }
const _hoisted_3 = { class: "window-title" }
const _hoisted_4 = { class: "code-content" }
const _hoisted_5 = { class: "line-numbers" }
const _hoisted_6 = { class: "code-text" }



interface Props {
  filename: string
  totalLines: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CodeEditor',
  props: {
    filename: {},
    totalLines: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "window-controls" }, [
        _createElementVNode("div", { class: "control close" }),
        _createElementVNode("div", { class: "control minimize" }),
        _createElementVNode("div", { class: "control maximize" })
      ], -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.filename), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalLines, (lineNumber) => {
          return (_openBlock(), _createElementBlock("span", { key: lineNumber }, _toDisplayString(lineNumber), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})